"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YUZEY_OKUMA_SAPKALARI = exports.YUZEY_ANAHTARLARI = exports.GOREVLENDIRME_LISTESI_OKUMA_SAPKALARI = exports.GOREV_LISTESI_OKUMA_SAPKALARI = exports.OLAY_YAPILANDIRMA_OKUMA_SAPKALARI = exports.PTW_YAPILANDIRMA_OKUMA_SAPKALARI = void 0;
exports.cozYuzeyler = cozYuzeyler;
const gorev_1 = require("./gorev");
const modul_rolleri_1 = require("./modul-rolleri");
/**
 * MODÜL İÇİ YAPILANDIRMA YÜZEYLERİ — GÖRÜNÜRLÜK SUNUCUDAN GELİR
 * (F4·S5·B1 — Kapsam §20.3a / IA §3/4; F3·S4 `yetkiler` deseninin sekme kolu).
 *
 * ⚠️ **GÖRÜNMEYEN SEKMENİN UCU DA 403.** Bunu sağlayan şey, sekmenin
 * görünürlüğünü hesaplayan listenin, o sekmenin ucundaki `@RequireRole`
 * listesinin **TA KENDİSİ** olmasıdır — ekranda ikinci bir şapka listesi
 * yazılmaz. Aksi hâlde *"görüyorum ama tıklayınca 403"* doğar ve müşteri
 * bunu **hata sanar** (kararın gerekçesi birebir budur).
 *
 * Desen `SAGLIK_OKUMA_SAPKALARI` ile aynıdır: tek kaynak burada durur,
 * uçlar `...LISTE` olarak yayar (`@RequireRole` değişken argüman ister),
 * `my-authorization` aynı listeden `yuzeyler` alanını üretir.
 *
 * ⚠️ Bu listeler **OKUMA** listeleridir. Yazma satırları (§20.5) DEĞİŞMEDİ
 * ve her uçta ayrıca durur — sekmeyi görmek yazabilmek demek değildir.
 */
/**
 * İŞ İZİNLERİ > Onay zincirleri + Yapılandırma sekmeleri.
 * Uçlar: `GET ptw/approval-chains` · `GET ptw/config`.
 */
exports.PTW_YAPILANDIRMA_OKUMA_SAPKALARI = ['holding_admin', 'viewer'];
/**
 * OLAYLAR > Şiddet seviyesi sekmesi. Uç: `GET incident-severity/config`.
 *
 * ⚠️ Bu liste PTW'ninkinden GENİŞTİR ve bu bilinçlidir — seviye ölçeğini
 * yazan holding yöneticisidir ama **türetmeyi okuyan herkes** ölçeği görmek
 * zorundadır (kayıttaki seviye rozeti oradan anlam kazanır).
 */
exports.OLAY_YAPILANDIRMA_OKUMA_SAPKALARI = [
    'holding_admin',
    'viewer',
    'company_admin',
    'location_manager',
    'isg_specialist',
];
/**
 * ✏️ MADDE 287 (yetki paketi artçısı, 29.09.2026 — Kapsam §20.9): İKİ LİSTE
 * SEKMESİ DE AYNI MEKANİZMAYA BAĞLANDI. Persona yoklaması sekmelere
 * genişleyince iki ayrışma ölçüldü: sekme çiziliyor, sekmenin ANA okuma ucu
 * 403 veriyordu.
 *
 *   gorevListesi         → İş ekipmanları > Periyodik görevler + Görev kuralları
 *                          (uçlar `GET tasks/occurrences` · `tasks/assignments` ·
 *                          `tasks/options`). Ekipman okuma listesi alan
 *                          sorumlusunu tanır, görev okuma listesi tanımaz.
 *   gorevlendirmeListesi → Çalışanlar > Görevlendirmeler (uç `GET designations`).
 *                          Çalışan okuma listesi tur 9'da tüm iç şapkalara
 *                          açıldı, görevlendirme okuma listesi açılmadı.
 *
 * Karar ÇAĞIRMA sınıfındadır (sekme çizilmez): listeyi bir şapkaya açmak yeni
 * bir veri alanıdır ve ürün kararı ister. Sabitler KOPYALANMAZ — uçların
 * okuduğu sabitin kendisidir.
 *
 * ✏️ MADDE 292 (yetki artçısı 2 — ürün sahibi kararı A, 30.09.2026):
 * görevlendirme listesi lokasyon yöneticisi ve İSG teknikerine AÇILDI. Bu
 * dosyada hiçbir şey değişmedi — sabit (`GOREVLENDIRME_OKUMA_SAPKALARI`)
 * genişledi, sekme görünürlüğü onu İZLEDİ (mekanizmanın varlık sebebi).
 */
exports.GOREV_LISTESI_OKUMA_SAPKALARI = gorev_1.GOREV_OKUMA_SAPKALARI;
exports.GOREVLENDIRME_LISTESI_OKUMA_SAPKALARI = modul_rolleri_1.GOREVLENDIRME_OKUMA_SAPKALARI;
/**
 * Kabuğun sunucudan okuduğu yüzey anahtarları. Menü ve sekmeler bunu
 * okur; **istemcide şapka listesi tutulmaz.**
 */
exports.YUZEY_ANAHTARLARI = [
    'ptwYapilandirma',
    'olayYapilandirma',
    'gorevListesi',
    'gorevlendirmeListesi',
];
/** Anahtar → okuma listesi. Envanter testi ikisini TAM EŞİTLİKLE kilitler. */
exports.YUZEY_OKUMA_SAPKALARI = {
    ptwYapilandirma: exports.PTW_YAPILANDIRMA_OKUMA_SAPKALARI,
    olayYapilandirma: exports.OLAY_YAPILANDIRMA_OKUMA_SAPKALARI,
    gorevListesi: exports.GOREV_LISTESI_OKUMA_SAPKALARI,
    gorevlendirmeListesi: exports.GOREVLENDIRME_LISTESI_OKUMA_SAPKALARI,
};
/** Kullanıcının şapka kümesinden yüzey görünürlüğünü çözer (tek yüklem). */
function cozYuzeyler(sapkalar) {
    const sonuc = {};
    for (const anahtar of exports.YUZEY_ANAHTARLARI) {
        sonuc[anahtar] = exports.YUZEY_OKUMA_SAPKALARI[anahtar].some((rol) => sapkalar.includes(rol));
    }
    return sonuc;
}
//# sourceMappingURL=yuzey.js.map